import * as Yup from 'yup'

const nameFormSchema = Yup.object({
  firstname: Yup.string().required('Debes especificar tu nombre'),
  lastname: Yup.string().required('Debes especificar tus apellidos'),
})

export default nameFormSchema
